// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"07d3e746","453":"06f1b13c","775":"62107acd","863":"a6bc5643"}[chunkId] + ".chunk.js";
};